import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import "./LoadingSpinner.scss"

class LoadingSpinner extends Component {
  render() {
    return (
        <div className="hrb-loading-spinner">
            <FontAwesomeIcon icon={faSpinner} pulse />
        </div>
    );
  }
}

export default LoadingSpinner;